import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';
import { MenuComponent } from './layout/dossier/menu/menu.component';
import { SelezionecuaaComponent } from './layout/dossier/selezionecuaa/selezionecuaa.component';
const routes: Routes = [

    {path: '', redirectTo: 'menu', pathMatch: 'full'},
    { path: 'menu', component: MenuComponent, canActivate: [AuthGuard] },
    { path: 'fascicolo', loadChildren: './layout/layout.module#LayoutModule', canActivate: [AuthGuard] },
    { path: 'selezionecuaa', component: SelezionecuaaComponent, canActivate: [AuthGuard] },
    { path: 'error', loadChildren: './server-error/server-error.module#ServerErrorModule' },
    { path: 'not-found', loadChildren: './not-found/not-found.module#NotFoundModule' },
    { path: '**', redirectTo: 'login' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: false})],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
